const gtmDataLayer = typeof window !== 'undefined' ? window.dataLayer || [] : [];
import { dateToJavaTimeConverterGTM } from 'Utils/dateConverters';
import { EVENT_FIELD_MAPPING, GTA_SPORT_TYPE_NAMING, GTM_PAGE_MAPPER, SPORT_TYPE_BY_URL, URL_MAP_BY_TYPE } from 'Store/constants/sportTypes';


// As per standardization efforts on SEM issues, this function makes values in an object lowercase, recursively.
function lowercaseObjectValues (obj) {

  let result = {};
  // Function to process individual values
  const processValue = value => {
    if (typeof value === 'string') {
      // Lowercase for string values
      return value.toLowerCase();
    } else if (Array.isArray(value)) {
      // Recurse for each item in an array
      return value.map(item => processValue(item));
    } else if (typeof value === 'object' && value !== null) {
      // Recurse for object values
      return lowercaseObjectValues(value);
    } else {
      // Return other types of values as is
      return value;
    }
  };
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      result[key] = processValue(obj[key]);
    }
  }
  return result;
}

const purchaseWrapper = eventArgs => (
  {
    purchase: {
      actionField: {
        affiliation: 'İddaa',
        id: eventArgs.transaction_id,
        revenue: eventArgs.value,
        dimension13: eventArgs.max_profit,
        dimension14: eventArgs.total_ratio,
        dimension15: eventArgs.system,
        dimension16: eventArgs.multiple_coupon_count,
        dimension17: eventArgs.value
      },
      products: eventArgs.items
    }
  }
);

const purchaseSporTotoWrapper = eventArgs => {
  return eventArgs;
};

const checkoutWrapper = eventArgs => (
  {
    checkout: {
      actionField: {
        step: 2,
        dimension13: eventArgs.max_profit,
        dimension14: eventArgs.total_ratio,
        dimension15: eventArgs.system,
        dimension16: eventArgs.multiple_coupon_count,
        dimension17: eventArgs.value
      },
      products: eventArgs.items
    }
  }
);

const checkoutViewWrapper = eventArgs => (
  {
    checkout: {
      actionField: {
        affiliation: 'Eşya Piyangosu',
        revenue: eventArgs.price,
        step: eventArgs.quantity
      },
      products: eventArgs.items
    }
  }
);

const betSlipViewedWrapper = eventArgs => (
  {
    checkout: {
      actionField: {
        step: 1,
        dimension13: eventArgs.max_profit,
        dimension14: eventArgs.total_ratio,
        dimension15: eventArgs.system,
        dimension16: eventArgs.multiple_coupon_count,
        dimension17: eventArgs.value
      },
      products: eventArgs.items
    }
  }
);

const productListWrapper = eventArgs => {
  let currDate = new Date();
  return [{
    id: eventArgs.items[0].id,
    name: eventArgs.items[0].name,
    brand: eventArgs.tabName === 'Şans Oyunları' ? eventArgs.items[0].brand : GTA_SPORT_TYPE_NAMING[eventArgs.items[0].brand],
    category: eventArgs.items[0].category,
    dimension8: eventArgs.tabName === 'Şans Oyunları' ? dateToJavaTimeConverterGTM() : eventArgs.items[0].dimension8,
    dimension9: eventArgs.tabName === 'Şans Oyunları' ? currDate.getHours() + ':' + currDate.getMinutes() : eventArgs.items[0].dimension9,
    dimension10: eventArgs.items[0].banker,
    dimension11: eventArgs.items[0].dimension11,
    dimension12: eventArgs.tabName === 'Şans Oyunları' ? eventArgs?.items[0]?.dimension12 : eventArgs?.items[0]?.mbs,
    price: eventArgs.items[0].price,
    variant: eventArgs.items[0].variant,
    position: eventArgs.items[0].position,
    banker: eventArgs.items[0].banker
  }];

};

const productViewWrapper = eventArgs => (
  {
    detail: {
      products: productListWrapper(eventArgs)
    }
  }
);

const productClickWrapper = eventArgs => {
  return (
    {
      click: {
        actionField: {
          list: eventArgs.tabName !== 'Şans Oyunları' ? eventArgs.tabName + ' - ' + eventArgs.tabType : eventArgs.tabName
        },
        products: productListWrapper(eventArgs)
      }
    }
  );
};


const promotionWrapper = eventArgs => {
  const bannerId = eventArgs?.id ? eventArgs?.id.toString() : null;

  return (
    {
      promoView: {
        promotions: [{ id: bannerId, name: eventArgs.name, position: `${eventArgs.list} | Slider | ${eventArgs.position}` }]
      }
    }
  );
};


const campaignPromotionWrapper = eventArgs => {
  return (
    {
      promoView: {
        promotions: eventArgs?.items
      }
    }
  );
};


const promotionClickWrapper = eventArgs => {
  const bannerId = eventArgs?.id ? eventArgs?.id.toString() : null;
  const name = eventArgs.name ? eventArgs.name : eventArgs.title;
  let type = 'slider';
  if (eventArgs.list === 'Kampanyalar Page') {
    type = 'banner';
  }

  return (
    {
      promoClick: {
        promotions: [{ id: bannerId, name: name, position: `${eventArgs.list} | ${type} | ${eventArgs.position}` }]
      }
    }
  );
};

const impressionWrapper = eventArgs => {

  const impressionsList = [];
  eventArgs?.list.forEach(list => {
    //TODO: position -> sonradan eklenecek
    const listObject = {
      id: list.id.toString(),
      name: list[EVENT_FIELD_MAPPING.eventName] ? list[EVENT_FIELD_MAPPING.eventName] : list.homeTeam + ' - ' + list.awayTeam,
      brand: GTA_SPORT_TYPE_NAMING[list[EVENT_FIELD_MAPPING.sportType]] ? GTA_SPORT_TYPE_NAMING[list[EVENT_FIELD_MAPPING.sportType]] : URL_MAP_BY_TYPE[list.sportType],
      category: list[EVENT_FIELD_MAPPING.leagueName],
      list: `${eventArgs.tabName} - ${eventArgs.tabType}`,
      dimension8: list[EVENT_FIELD_MAPPING.eventStartDate] ? list[EVENT_FIELD_MAPPING.eventStartDate] : list.matchDate,
      dimension9: list[EVENT_FIELD_MAPPING.startTime] ? list[EVENT_FIELD_MAPPING.startTime] : String(new Date(list.matchDate).getHours()).padStart(2, '0') + ':' + String(new Date(list.matchDate).getMinutes()).padStart(2, '0'),
      dimension11: list[EVENT_FIELD_MAPPING.bettingPhase] ? 'YES' : 'NO',
      dimension12: list.mbs?.toString(),
      price: null,
      variant: null,
      position: null,
      banker: null
    };

    impressionsList.push(listObject);
  });

  return (
    {
      impressions: impressionsList
    }
  );
};

const impressionWrapperForLiveStream = eventArgs => {
  const impressionsList = [];
  eventArgs?.list.forEach(list => {
    //TODO: position -> sonradan eklenecek
    const listObject = {
      id: list.sbsEventId,
      name: list.homeTeam + ' - ' + list.awayTeam,
      brand: URL_MAP_BY_TYPE[list.sportType],
      category: list.tournamentName,
      list: `${eventArgs.tabName} - ${eventArgs.tabType}`,
      dimension8: list.matchDate,
      dimension9: new Date(list.matchDate).getHours() + ':' + ((new Date(list.matchDate).getMinutes() < 10 ? '0' : '') + new Date(list.matchDate).getMinutes()),
      dimension11: 'NO',
      dimension12: null,
      price: null,
      variant: null,
      position: null,
      banker: null
    };

    impressionsList.push(listObject);
  });

  return (
    {
      impressions: impressionsList
    }
  );
};

const eventWrapper = type => eventArgs => {
  if (eventArgs && eventArgs.list) {
    return {
      [type]: {
        products: eventArgs.items
      }
    };
  } else {
    return {
      [type]: { ...eventArgs }
    };
  }
};

const gtmEvents = {
  add_to_cart: { action: 'Add to Cart', label: 'Add to Cart', noninteraction: true, wrapper: eventWrapper('add') },
  remove_from_cart: { action: 'Remove from Cart', label: 'Remove from Cart', noninteraction: true, wrapper: eventWrapper('remove') },
  purchase: { action: 'Purchase', label: 'Order Confirmation', wrapper: purchaseWrapper },
  purchase_sport_toto: { action: 'Purchase', label: 'Order Confirmation', wrapper: purchaseSporTotoWrapper },
  bet_slip_viewed: { action: 'Checkout', label: 'Checkout', Value: 0, wrapper: betSlipViewedWrapper, noninteraction: true },
  begin_checkout: { action: 'Checkout', label: 'Checkout', Value: 0, wrapper: checkoutWrapper },
  product_impression: { action: 'Product Impressions', label: 'Product Impressions', noninteraction: false, wrapper: impressionWrapper },
  product_impression_for_live_stream: { action: 'Product Impressions', label: 'Product Impressions', noninteraction: false, wrapper: impressionWrapperForLiveStream },
  promotion_impression: { action: 'Promotion', label: 'Promotion Impression', wrapper: promotionWrapper },
  promotion_click: { action: 'Promotion', label: 'Promotion Impression Click', wrapper: promotionClickWrapper },
  product_detail_view: { action: 'Product Detail', label: 'Product Detail View', noninteraction: true, wrapper: productViewWrapper },
  product_detail_click: { action: 'Product Impression', label: 'Product Impression Click', noninteraction: false, wrapper: productClickWrapper },
  register: { action: 'Register', label: 'Register Complete', Value: 0, noninteraction: false, wrapper: () => { } },
  promotion_impression_campaign: { action: 'Promotion', label: 'Promotion Impression', value: 0, noninteraction: false, wrapper: campaignPromotionWrapper },
  checkout_view: { action: 'Checkout View', label: 'Checkout - Eşya Piyangosu', Value: 10, noninteraction: false, wrapper: checkoutViewWrapper }
};

const standAloneGtmEvents = (eventName, eventArgs) => {
  const obj = {
    sign_up: {
      event: 'SEMgaEvent',
      eventCategory: 'Membership',
      eventLabel: 'New Membership',
      eventAction: 'New Membership'
    },
    tribun_coupon_like: {
      event: eventName,
      ...eventArgs
    },
    tribun_comment_made: {
      event: eventName,
      ...eventArgs
    },
    tribun_comment_deleted: {
      event: eventName,
      ...eventArgs
    },
    tribun_report_coupon: {
      event: eventName,
      ...eventArgs
    },
    tribun_product_view: {
      event: eventName,
      ...eventArgs
    },
    tribun_follow_tipster: {
      event: eventName,
      ...eventArgs
    },
    tribun_leaderboard: {
      event: eventName,
      ...eventArgs
    },
    joined_campaign: {
      event: 'SEMgaEvent',
      eventCategory: 'Campaigns',
      eventLabel: 'Joined Campaign',
      eventAction: 'Joined Campaign'
    },
    campaign_details: {
      event: 'campaign_details',
    },
    view_tarihte_bugun: {
      event: 'view_tarihte_bugun',
    },
    purchase_ep: {
      event: 'purchase_ep',
      ecommerce: eventArgs
    },
    purchase_sans_oyunlari: {
      event: 'purchase_sans_oyunlari',
      ecommerce: eventArgs
    },
    view_mac_karti: {
      event: eventName,
      ...eventArgs
    },
    view_item_list: {
      event: eventName,
      ...eventArgs
    },
    login: {
      event: eventName,
      ...eventArgs
    },
    logout: {
      event: eventName
    },
    begin_checkout_error: {
      event: eventName,
      ...eventArgs
    },
    tribune_follow_user: {
      event: eventName
    },
    search: {
      event: eventName,
      ...eventArgs
    },
    ecommerce_purchase_ep: {
      event: eventName,
      ...eventArgs
    },
    ecommerce_purchase_sk: {
      event: eventName,
      ...eventArgs
    },
    tribun_coupon_share: {
      event: eventName
    },
    share: {
      event: eventName
    }
  };

  return obj[eventName];
};

export const trackGTMEvent = (eventName, eventArgs = {}, tabName, tabType) => {
  tabName = tabName ?? '';
  tabType = tabType ?? '';
  if (eventName in gtmEvents) {
    let eventConfig = gtmEvents[eventName];

    let label;
    let value;
    if (tabName !== '') {
      if (tabType !== '') {
        label = `${eventConfig.label} - ${GTM_PAGE_MAPPER[tabName]} / ${GTA_SPORT_TYPE_NAMING[SPORT_TYPE_BY_URL[tabType]] || GTM_PAGE_MAPPER[tabType] || tabType}`;
      } else {
        label = `${eventConfig.label} - ${GTM_PAGE_MAPPER[tabName]}`;
      }
    } else {
      label = eventConfig.label;
    }

    if (eventConfig.Value === 0) {
      value = eventConfig.Value;
    } else if (eventArgs.value) {
      value = eventArgs.value;
    } else {
      value = 0;
    }

    gtmDataLayer.push({
      Category: 'Enhanced Ecommerce',
      Action: eventConfig.action,
      Label: (label && { label }),
      Value: value,
      noninteraction: eventConfig.noninteraction ?? false,
      ecommerce: {
        currencyCode: 'TRY',
        ...eventConfig.wrapper({ ...eventArgs, action: eventConfig.action, list: eventArgs.list, ...{ tabName, tabType } })
      },
      event: 'SEMeeEvent'
    });
  } else if (standAloneGtmEvents(eventName, eventArgs) !== undefined) {
    gtmDataLayer.push(standAloneGtmEvents(eventName, eventArgs));
  }

};

export const updateGTMDimensions = (config, obj) => {
  const gtmConfig = {};
  for (const [key, value] of Object.entries(config)) {
    gtmConfig[`cd_${key}`] = value;
  }
  if (obj) {
    for (const [key, value] of Object.entries(obj)) {
      gtmConfig[`${key}`] = value;
    }
  }
  gtmDataLayer.push(gtmConfig);
};

export const trackGTMEventV2 = (data, eventType, page) => {
  if ( eventType === 'campaign_details') {
    gtmDataLayer.push(
      lowercaseObjectValues({
        event: eventType,
        ...data
      })
    );
  }

  if (eventType === 'view_item_list' && page === 'populerBets') {
    gtmDataLayer.push(
      lowercaseObjectValues({
        event: eventType,
        ecommerce: {
          item_list_id: 'Home Page - Popüler',
          item_list_name: 'Home Page - Popüler',
          balance: data?.balance,
          items: data?.items
        }
      })
    );
  } else if (eventType === 'select_item' && page === 'populerBets') {
    gtmDataLayer.push(
      lowercaseObjectValues({
        event: eventType,
        ecommerce: {
          balance: data.balance,
          item_list_id: 'Home Page - Popüler',
          item_list_name: 'Home Page - Popüler',
          items: [data?.data]
        }
      })
    );
  } else if (eventType === 'view_item' && page === 'populerBets') {
    gtmDataLayer.push(
      lowercaseObjectValues({
        event: eventType,
        ecommerce: {
          balance: data.balance,
          item_list_id: 'Home Page - Popüler',
          item_list_name: 'Home Page - Popüler',
          items: [data?.data]
        }
      })
    );
  } else if (eventType === 'view_item_list' && page === 'populerBetsPage') {
    gtmDataLayer.push(
      lowercaseObjectValues({
        event: eventType,
        ecommerce: {
          item_list_id: 'Popüler Bahisler',
          item_list_name: 'Popüler Bahisler',
          items: data
        }
      })
    );
  } else if (eventType === 'select_item' && page === 'populerBetsPage') {
    gtmDataLayer.push(
      lowercaseObjectValues({
        event: eventType,
        balance: data.balance,
        ecommerce: {
          balance: data.balance,
          item_list_id: 'Popüler Bahisler',
          item_list_name: 'Popüler Bahisler',
          items: [data?.data]
        }
      })
    );
  } else if (eventType === 'view_item' && page === 'populerBetsPage') {
    gtmDataLayer.push(
      lowercaseObjectValues({
        event: eventType,
        balance: data.balance,
        ecommerce: {
          item_list_id: 'Popüler Bahisler',
          item_list_name: 'Popüler Bahisler',
          items: [data?.data]
        }
      })
    );
  } else if (eventType === 'view_item_list' && page === 'tribun') {
    gtmDataLayer.push(
      lowercaseObjectValues(lowercaseObjectValues())
    );
  } else if (eventType === 'select_item' && page === 'tribun') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: 'Tribün', // maçın görüntülendiği liste id’si
        item_list_name: 'Tribün', // maçın görüntülendiği liste adı
        items: [data?.data]
      }
    }));
  } else if (eventType === 'view_item' && page === 'tribun') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: 'Tribün', // maçın görüntülendiği liste id’si
        item_list_name: 'Tribün', // maçın görüntülendiği liste adı
        items: [data?.data]
      }
    }));
  } else if (eventType === 'view_item_list' && page === 'authors') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: `Yazarlar - ${data?.author}`,
        item_list_name: `Yazarlar - ${data?.author}`,
        items: data?.items
      }
    }));
  } else if (eventType === 'select_item' && page === 'authors') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: `Yazarlar - ${data?.author}`, // maçın görüntülendiği liste id’si
        item_list_name: `Yazarlar - ${data?.author}`, // maçın görüntülendiği liste adı
        items: data?.items
      }
    }));
  } else if (eventType === 'view_item' && page === 'authors') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: `Yazarlar - ${data?.author}`, // maçın görüntülendiği liste id’si
        item_list_name: `Yazarlar - ${data?.author}`, // maçın görüntülendiği liste adı
        items: data?.items
      }
    }));
  } else if (eventType === 'view_item_list' && page === 'next-live-matches') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: data?.category,
        item_list_name: data?.category,
        items: data?.items
      }
    }));
  } else if (eventType === 'select_item' && page === 'next-live-matches') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.category, // maçın görüntülendiği liste id’si
        item_list_name: data?.category, // maçın görüntülendiği liste adı
        items: data?.data
      }
    }));
  } else if (eventType === 'view_item' && page === 'next-live-matches') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.category, // maçın görüntülendiği liste id’si
        item_list_name: data?.category, // maçın görüntülendiği liste adı
        items: data?.data
      }
    }));
  } else if (eventType === 'view_item_list' && page === 'bulletin') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: `${data?.category}`,
        item_list_name: `${data?.category}`,
        items: data?.items
      }
    }));
  } else if (eventType === 'select_item' && page === 'bulletin') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.category,
        item_list_name: data?.category,
        items: data?.data
      }
    }));
  } else if (eventType === 'view_item' && page === 'bulletin') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.category,
        item_list_name: data?.category,
        items: data?.data
      }
    }));
  } else if (eventType === 'view_item' && page === 'sportoto') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data?.balance,
        item_list_id: 'sportoto',
        item_list_name: 'Spor toto',
        items: data?.item
      }
    }));


  } else if (eventType === 'view_item_list' && page === 'liveStreams') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      balance: data.balance,
      ecommerce: {
        item_list_id: data?.list_name,
        item_list_name: data?.list_name,
        items: data?.items
      }
    }));

  } else if (eventType === 'select_item' && page === 'liveStreams') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.list_name,
        item_list_name: data?.list_name,
        items: data?.items
      }
    }));


  } else if (eventType === 'view_item' && page === 'liveStreams') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.list_name,
        item_list_name: data?.list_name,
        items: data?.items
      }
    }));
  } else if (eventType === 'login' && page === 'login') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: 'login',
      user_id: data?.user_id,
      user_balance: data?.user_balance
    }));
  } else if (eventType === 'view_item_list' && page === 'liveMatchesWidget') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: data?.category,
        item_list_name: data?.category,
        items: data?.items
      }
    }));
  } else if (eventType === 'select_item' && page === 'liveMatchesWidget') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.category,
        item_list_name: data?.category,
        items: data?.data
      }
    }));
  } else if (eventType === 'view_item' && page === 'liveMatchesWidget') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.category,
        item_list_name: data?.category,
        items: data?.data
      }
    }));
  } else if (eventType === 'view_item_list' && page === 'authorList') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: 'Yazarlar',
        item_list_name: 'Yazarlar',
        items: data
      }
    }));

  } else if (eventType === 'select_item' && page === 'authorList') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data?.balance,
        item_list_id: 'Yazarlar',
        item_list_name: 'Yazarlar',
        items: data?.items
      }
    }));

  } else if (eventType === 'view_item' && page === 'authorList') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data?.balance,
        item_list_id: 'Yazarlar',
        item_list_name: 'Yazarlar',
        items: data?.items
      }
    }));

  } else if (eventType === 'view_item_list' && page === 'liveScores') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: `${data?.itemListName}`,
        item_list_name: `${data?.itemListName}`,
        items: data?.items
      }
    }));
  } else if (eventType === 'select_item' && page === 'liveScores') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.itemListName,
        item_list_name: data?.itemListName,
        items: data?.items
      }
    }));
  } else if (eventType === 'view_item' && page === 'liveScores') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        balance: data.balance,
        item_list_id: data?.itemListName,
        item_list_name: data?.itemListName,
        items: data?.items
      }
    }));
  } else if (eventType === 'view_item_list' && page === 'chanceGames') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      balance: data.balance,
      ecommerce: {
        item_list_id: 'şans_oyunları',
        item_list_name: 'Şans Oyunları',
        items: data?.items
      }
    }));

  } else if (eventType === 'select_item' && page === 'chanceGames') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      balance: data.balance,
      ecommerce: {
        balance: data.balance,
        item_list_id: 'şans_oyunları',
        item_list_name: 'Şans Oyunları',
        items: data?.items
      }
    }));
  } else if (eventType === 'view_item' && page === 'chanceGames') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      balance: data.balance,
      ecommerce: {
        balance: data.balance,
        item_list_id: 'şans_oyunları',
        item_list_name: 'Şans Oyunları',
        items: data?.items
      }
    }));
  } else if (eventType === 'view_item_list' && page === 'homePageBanner') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: 'Home Page - Banner',
        item_list_name: 'Home Page - Banner',
        items: data?.items
      }
    }));
  } else if (eventType === 'select_item' && page === 'homePageBanner') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: 'Home Page - Banner',
        item_list_name: 'Home Page - Banner',
        items: data?.items
      }
    }));
  } else if (eventType === 'view_item' && page === 'homePageBanner') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: 'Home Page - Banner',
        item_list_name: 'Home Page - Banner',
        items: data?.items
      }
    }));
  } else if (eventType === 'login' && page === 'login') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      user_id: data?.user_id
    }));
  } else if (eventType === 'sign_up' && page === 'signUp') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      user_id: data?.user_id
    }));
  }
};


export const trackTjkGTM = (data, eventType) => {
  if (eventType === 'add_to_cart' || eventType === 'view_item') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        currency: 'TRY',
        value: 1.00, //Zorunlu parametre olmasından dolayı 1.00 olarak basılmalı
        items: [data]
      }
    }));
  } else if (eventType === 'view_item_list') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        item_list_id: 'tjk_at_yarisi', // Ganyanın görüntülendiği liste id’si
        item_list_name: 'TJK - At Yarışı', // Ganyanın görüntülendiği liste adı
        items: data
      }
    }));
  } else if (eventType === 'select_item') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        items: [data]
      }
    }));
  } else if (eventType === 'view_cart') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        currency: 'TRY',
        value: data?.cost,
        items: data?.trackTjkObj
      }
    }));
  } else if (eventType === 'begin_checkout') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        currency: 'TRY',
        value: data?.cost,
        items: data?.trackTjkObj
      }
    }));
  } else if (eventType === 'purchase') {
    gtmDataLayer.push(lowercaseObjectValues({
      event: eventType,
      ecommerce: {
        currency: 'TRY',
        value: data?.cost,
        items: data?.trackTjkObj
      }
    }));
  }
};
